import React from 'react';
import { Card, Title, Text, Box, Group, Paper, Stack, ThemeIcon, Divider } from '@mantine/core';
import { IconMapPin, IconPhone, IconUser } from '@tabler/icons-react';
import { DestinationAddressProps } from './types';

const DestinationAddress: React.FC<DestinationAddressProps> = ({ destination }) => {

    return (
        <Card shadow="sm" p={{ base: "sm", sm: "lg" }} radius="md" withBorder>
            <Group justify="space-between" align="flex-start" mb="md">
                <Title order={3} p={{ base: "h4", sm: "h3" }}>Delivery Address</Title>

            </Group>

            {/* Mobile-First Layout */}
            <Box display={{ base: 'block', sm: 'none' }}>
                <Paper withBorder p="sm" radius="md" bg="gray.0">
                    <Stack gap="sm">
                        {/* Recipient Name */}
                        <Group gap="xs" align="center">
                            <ThemeIcon size="sm" color="blue" variant="light">
                                <IconUser size={14} />
                            </ThemeIcon>
                            <Box>
                                <Text size="xs" c="dimmed">Recipient</Text>
                                <Text fw={700} size="sm">{destination.name}</Text>
                            </Box>
                        </Group>

                        <Divider />

                        {/* Address */}
                        <Group gap="xs" align="flex-start">
                            <ThemeIcon size="sm" color="blue" variant="light" mt={2}>
                                <IconMapPin size={14} />
                            </ThemeIcon>
                            <Box flex={1}>
                                <Text size="xs" c="dimmed" mb={2}>Address</Text>
                                <Text size="sm" style={{ lineHeight: 1.4 }}>
                                    {destination.street}
                                </Text>
                                <Text size="sm" style={{ lineHeight: 1.4 }}>
                                    {destination.city}, {destination.state} {destination.postalCode}
                                </Text>
                                <Text size="sm" fw={500}>
                                    {destination.country}
                                </Text>
                            </Box>
                        </Group>

                        {/* Phone */}
                        {destination.phone && (
                            <>
                                <Divider />
                                <Group gap="xs" align="center">
                                    <ThemeIcon size="sm" color="blue" variant="light">
                                        <IconPhone size={14} />
                                    </ThemeIcon>
                                    <Box>
                                        <Text size="xs" c="dimmed">Phone</Text>
                                        <Text fw={500} size="sm" c="blue">{destination.phone}</Text>
                                    </Box>
                                </Group>
                            </>
                        )}
                    </Stack>
                </Paper>
            </Box>

            {/* Desktop Layout */}
            <Box display={{ base: 'none', sm: 'block' }}>
                <Stack gap="md">
                    <Group gap="md" align="flex-start">
                        <ThemeIcon size="lg" color="blue" variant="light">
                            <IconUser size={20} />
                        </ThemeIcon>
                        <Box flex={1}>
                            <Text fw={700} size="lg" mb="xs">{destination.name}</Text>
                            <Text size="md" style={{ lineHeight: 1.5 }}>
                                {destination.street}
                            </Text>
                            <Text size="md" style={{ lineHeight: 1.5 }}>
                                {destination.city}, {destination.state} {destination.postalCode}
                            </Text>
                            <Text size="md" fw={500} mb="sm">
                                {destination.country}
                            </Text>
                            {destination.phone && (
                                <Group gap="xs" align="center">
                                    <IconPhone size={16} style={{ color: 'var(--mantine-color-blue-6)' }} />
                                    <Text c="blue" fw={500} size="md">{destination.phone}</Text>
                                </Group>
                            )}
                        </Box>
                    </Group>
                </Stack>
            </Box>

            {/* Quick Actions for Mobile */}
            {/* <Box mt="md" display={{ base: 'block', sm: 'none' }}>
                <Group grow>
                    <Button
                        variant="light"
                        size="sm"
                        leftSection={<IconMapPin size={16} />}
                    >
                        View on Map
                    </Button>
                    {destination.phone && (
                        <Button
                            variant="light"
                            size="sm"
                            component="a"
                            href={`tel:${destination.phone}`}
                            leftSection={<IconPhone size={16} />}
                        >
                            Call
                        </Button>
                    )}
                </Group>
            </Box> */}
        </Card>
    );
};

export default DestinationAddress;
